import { Suspense, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import AuthInit from './modules/auth/redux/AuthInit'
import { ThemeModeProvider } from '../_metronic/partials'
import { getAuthSyncChannel, subscribeAuthChange } from '../setup/auth/authSync'

const App = () => {
  const navigate = useNavigate()

  // Listen for logout event from axios interceptors
  useEffect(() => {
    const handleLogout = () => {
      // Navigate to login page using React Router (no page reload)
      if (!window?.location?.href.includes('/auth'))
        navigate('/auth/login', { replace: true })
    }

    const handleForbidden = () => {
      // Navigate to org dashboard on 403 forbidden
      navigate('/org-dashboard', { replace: true })
    }

    window.addEventListener('auth:logout', handleLogout)
    window.addEventListener('auth:forbidden', handleForbidden)

    return () => {
      window.removeEventListener('auth:logout', handleLogout)
      window.removeEventListener('auth:forbidden', handleForbidden)
    }
  }, [navigate])

  // Reconcile across browser tabs. The session cookie is shared origin-wide, so
  // when another tab logs in or out it silently changes the identity this tab is
  // authenticated as. Re-bootstrap with a hard reload so the tab picks up the
  // new (or absent) session instead of operating on stale identity/org state.
  useEffect(() => {
    const channel = getAuthSyncChannel()
    if (!channel) return

    const unsubscribe = subscribeAuthChange(channel, () => {
      window.location.reload()
    })

    return unsubscribe
  }, [])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <ThemeModeProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </ThemeModeProvider>
      </LayoutProvider>
    </Suspense>
  )
}

export { App }
